// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2Zys8","errorLogs":"EditorFooter_errorLogs__C7gDQ"};